const OverView = () => import(/* webpackChunkName: "serverShift" */ '@/components/dashboard/overview')
export default {
    name: 'overview',
    path: 'overview',
    redirect: '/overview/index',
    meta: {label: 'overview'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'overview', auth: true},
            component: OverView,
            props: true
        }
    ]
}
